const pathToCnMap = {
  create: '新增',
  edit: '编辑',
  detail: '详情',
  generalInfo:'新闻资讯',
  talentList: '人才团队列表',
  talentDetail: '人才详情页',
  IndustryInformation: '专利信息分析',
  IndustryInformationList: '专利信息分析列表',
  IndustryInformationDetail: '产业信息列表详情页',
  IndustryNavigationList: '产业导航列表',
  IndustryNavigationDetail: '产业导航列表详情',
}

function getCurrentCrumb(path) {
  const paths = path.split('/').filter(Boolean) // 获取所有路径
  return paths.reduce((pre, cur) => {
    pre.push({
      name: pathToCnMap[cur],
      toRouter: cur
    })
    return pre
  }, [])
}

module.exports = {
  getCurrentCrumb
}
